import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  Typography,
  SelectChangeEvent
} from '@mui/material';
import { Button } from 'base/src/components/Button';
import Drawer from 'base/src/components/Drawer';

interface StatusOption {
  id: string;
  nome: string;
}

export interface FilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  statusFilter: string[];
  // eslint-disable-next-line no-unused-vars
  onStatusFilterChange: (event: SelectChangeEvent<string[]>) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  statusOptions: StatusOption[];
}

function FilterDrawer({
  isOpen,
  onClose,
  statusFilter,
  onStatusFilterChange,
  onApplyFilters,
  onClearFilters,
  statusOptions
}: FilterDrawerProps) {

  // Render selected values in multi-select
  function renderSelectedValues(selected: string[]) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((value) => {
          const status = statusOptions.find(s => s.id === value);
          return (
            <Chip
              key={value}
              label={status?.nome}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                borderRadius: 1,
                height: 20,
                fontSize: '0.75rem'
              }}
            />
          );
        })}
      </Box>
    );
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 3, color: 'grey.800', fontWeight: 600 }}>
          Filtros
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              multiple
              value={statusFilter}
              onChange={onStatusFilterChange}
              label="Status"
              renderValue={renderSelectedValues}
              sx={{
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'primary.main',
                },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <Button
              size="md"
              variant="primary"
              onClick={onApplyFilters}
              full
            >
              Aplicar Filtros
            </Button>
            <Button
              size="md"
              variant="secondary"
              onClick={onClearFilters}
              full
            >
              Limpar
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}

export default FilterDrawer;
